/**
 * Formata um plano de GET /billing/planos (`valor_centavos` + `moeda`).
 * Devolve `null` se os dados não forem utilizáveis.
 */
export const formatPrice = (plano) => {
  if (!plano || !Number.isFinite(plano.valor_centavos)) return null;

  const amount = plano.valor_centavos / 100;

  try {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: (plano.moeda || "brl").toUpperCase(),
      minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
    }).format(amount);
  } catch {
    return null;
  }
};
